import type { CSSProperties } from 'react';

interface FavoriteItemSelectionStyles {
    button: CSSProperties;
    row: CSSProperties;
}

/** Keeps the active treatment on the navigation control, never its hover-action row. */
export const getFavoriteItemSelectionStyles = (
    active: boolean,
    activeBackground: string,
): FavoriteItemSelectionStyles => ({
    button: { backgroundColor: active ? activeBackground : undefined },
    row: { backgroundColor: undefined },
});
